import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { GetAllQuizs } from "../../api/Quiz/GetAllQuizs";
import Spinner from "../../components/Shared/Spinner";
import TrashIcon from "../../components/Icons/TrashIcon";
import { Quiz } from "../../api/Quiz/GetAllQuizs";
import DeleteModal from "../../components/Shared/DeleteModal";
import { useState } from "react";
import { DeleteMCQ, DeleteEssay, DeleteExam } from "../../api/Quiz/DeleteQuiz";
import { toast } from "react-toastify";

const DeleteQuiz = () => {
    const { id } = useParams();
    const courseId = id || "";
    const [isMCQOpen, setIsMCQOpen] = useState(false);
    const [isEssayOpen, setIsEssayOpen] = useState(false);
    const [isExamOpen, setIsExamOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<string | null>(null);

    const { data: QuizsDTO, isLoading: isQuizLoading } = useQuery({
        queryFn: () => GetAllQuizs(courseId),
        queryKey: ["quiz", courseId],
        staleTime: 0,
        refetchInterval: 0,
    });
    const quizs = QuizsDTO?.data;
    if (isQuizLoading)
        return (
            <div className="min-h-[80vh] flex items-center justify-center">
                <Spinner />
            </div>
        );
    if (!quizs) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p>No data available</p>
            </div>
        );
    }
    const handleDeleteMCQ = async (id: string) => {
        await DeleteMCQ(id);
        toast.success("MCQ Quiz deleted successfully");
    };
    const handleDeleteEssay = async (id: string) => {
        await DeleteEssay(id);
        toast.success("Essay Quiz deleted successfully");
    };
    const handleDeleteExam = async (id: string) => {
        await DeleteExam(id);
        toast.success("Exam Quiz deleted successfully");
    };

    const { quiz, essay, exams } = quizs;

    return (
        <div>
            <div className="flex justify-between items-center py-7">
                <h1 className="text-burntBlack font-bold text-[32px]">All Quizzes</h1>
            </div>
            <div>
                {quiz && quiz.map((mcq: Quiz, index: number) => (
                    <div key={mcq.id} className="flex justify-between items-center py-4 border-b border-gray-200 relative">
                        <span>MCQ {index + 1}. {mcq.title}</span>
                        <button
                            onClick={() => {
                                setSelectedId(mcq.id);
                                setIsMCQOpen(true);
                            }}
                            className="bg-red-500 text-white px-4 py-2 rounded flex items-center gap-2 duration-300 transition-all hover:bg-red-900 absolute right-0"
                        >
                            Delete <TrashIcon />
                        </button>
                        <DeleteModal
                            isOpen={isMCQOpen}
                            setIsOpen={setIsMCQOpen}
                            mutationFn={() => handleDeleteMCQ(selectedId!)}
                            itemId={selectedId!}
                            queryKey="quiz"
                        />
                    </div>
                ))}
                {essay && essay.map((essay: Quiz, index: number) => (
                    <div key={essay.id} className="flex justify-between items-center py-4 border-b border-gray-200 relative">
                        <span>ESSAY {index + 1}. {essay.title}</span>
                        <button
                            onClick={() => {
                                setSelectedId(essay.id);
                                setIsEssayOpen(true);
                            }}
                            className="bg-red-500 text-white px-4 py-2 rounded flex items-center gap-2 duration-300 transition-all hover:bg-red-900 absolute right-0"
                        >
                            Delete <TrashIcon />
                        </button>
                        <DeleteModal
                            isOpen={isEssayOpen}
                            setIsOpen={setIsEssayOpen}
                            mutationFn={() => handleDeleteEssay(selectedId!)}
                            itemId={selectedId!}
                            queryKey="quiz"
                        />
                    </div>
                ))}
                {exams && exams.map((exam: Quiz, index: number) => (
                    <div key={exam.id} className="flex justify-between items-center py-4 border-b border-gray-200 relative">
                        <span>EXAM {index + 1}. {exam.title}</span>
                        <button
                            onClick={() => {
                                setSelectedId(exam.id);
                                setIsExamOpen(true);
                            }}
                            className="bg-red-500 text-white px-4 py-2 rounded flex items-center gap-2 duration-300 transition-all hover:bg-red-900 absolute right-0"
                        >
                            Delete <TrashIcon />
                        </button>
                        <DeleteModal
                            isOpen={isExamOpen}
                            setIsOpen={setIsExamOpen}
                            mutationFn={() => handleDeleteExam(selectedId!)}
                            itemId={selectedId!}
                            queryKey="quiz"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DeleteQuiz;
